import { render, staticRenderFns } from "./emailSettingsElement.vue?vue&type=template&id=b16f89a6&scoped=true&"
import script from "./emailSettingsElement.vue?vue&type=script&lang=js&"
export * from "./emailSettingsElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16f89a6",
  null
  
)

export default component.exports